import Keyboard from "react-simple-keyboard";
import { useState } from "react";
import "react-simple-keyboard/build/css/index.css";

const arabicLayout = {
  default: [
    "ذ 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
    "{tab} ض ص ث ق ف غ ع ه خ ح ج د",
    "{lock} ش س ي ب ل ا ت ن م ك ط {enter}",
    "{shift} ئ ء ؤ ر لا ى ة و ز ظ {shift}",
    "{space}"
  ],
  shift: [
    "ّ ! @ # $ % ^ & * ( ) _ + {bksp}",
    "{tab} َ ً ُ ٌ إ ‘ ÷ × ؛ < >",
    "{lock} ِ ٍ ] [ لأ أ ـ ، / : {enter}",
    "{shift} ~ ْ } { آ ’ , . ؟ {shift}",
    "{space}"
  ]
};

export default function ArabicKeyboard({ onChange }) {
  const [layoutName, setLayoutName] = useState("default");

  return (
    <Keyboard
      layout={arabicLayout}
      layoutName={layoutName}
      onChange={onChange}
      onKeyPress={(button) => {
        if (button === "{shift}" || button === "{lock}") {
          setLayoutName(prev =>
            prev === "default" ? "shift" : "default"
          );
        }
        if (button === "{clear}") {
          onChange("");
        }
      }}
      display={{
        "{bksp}": "⌫",
        "{enter}": "Enter",
        "{shift}": "Shift",
        "{lock}": "Caps",
        "{space}": "Space"
      }}
      rtl
    />
  );
}
